/** «Лиды по дням» — ровно то, что отдаёт `GET /api/leads/days`. */
import { apiFetch, query } from "@/lib/api";

export type LeadDayCounts = {
  leads: number;
  /** Российский номер (`ru_phone`), как в «По номерам». */
  valid_phone: number;
  /** С рабочим номером и не дубль/спам/реклама/вакансии. */
  in_work: number;
  /** Уникальных номеров «в работе» в строке. */
  phones: number;
  /** Из них без лидов за 90 дней до первого лида строки. */
  new: number;
  deal: number;
  recorded: number;
  booked: number;
  /** Те же уникальные номера по тому, кто завёл номер (ключи — `channels`); сумма = `phones`. */
  by?: Record<string, number>;
  /** Воронка каждого канала (ключи — `channels`); по каждому полю сумма каналов = значение строки. */
  funnel?: Record<string, LeadChannelFunnel>;
};

export type LeadChannelFunnel = { phones: number; new: number; deal: number; recorded: number; booked: number };

export type LeadChannel = { key: string; label: string };

export type LeadDay = LeadDayCounts & { day: string; to: string };

export type LeadDays = {
  from: string;
  to: string;
  /** Отбор месяцев (1–12), по которому посчитаны строки и итог; пусто — все месяцы. */
  pick_months?: number[];
  /** Нет у ответа бэкенда до 07.10.26 — экран тогда без колонок каналов. */
  channels?: LeadChannel[];
  total: LeadDayCounts;
  days: LeadDay[];
  weeks: LeadDay[];
  months: LeadDay[];
};

export function loadLeadDays(from: string, to: string, months = ""): Promise<LeadDays> {
  return apiFetch<LeadDays>(`/api/leads/days${query({ from, to, months })}`);
}
